<script lang="ts">
  import SectionBoard from "../../molecules/SectionBoard.svelte";
  import { onMount } from "svelte";
  import BlueButton from "../BlueButton.svelte";
  import Pagination from "../../molecules/Pagination.svelte";
  import { HeadService } from "../../services/headservice";
  import ListItem from "../../atoms/ListItem.svelte";
  import DetailSection from "../../organisms/masters/DetailSection.svelte";
  import FormWithLabel from "../../molecules/FormWithLabel.svelte";

  const name = "head";
  const label = "個別ヘッド";
  const service = new HeadService(name);
  let loading = service.store.loading;
  let model = service.store.model;
  let models = service.store.models;
  let page = service.store.page;
  let size = service.store.size;

  onMount(async () => {
    await service.getList();
  });
</script>

<div class="flex">
  <SectionBoard>
    <h2 class="font-semibold">
      {label}
    </h2>

    <BlueButton click={service.add} klass="mt-4" rounded>追加</BlueButton>

    {#if $models.length !== 0}
      <div class="mt-4">
        {#each $models as m (m.id)}
          <ListItem
            handleModel={service.handleModel}
            model={m}
            selected={$model}
          />
        {/each}

        <Pagination
          page={$page}
          result={$models.length}
          next={service.handleNext}
          previous={service.handlePrevious}
          klass="mt-4"
        />
      </div>
    {/if}
  </SectionBoard>

  {#if $model.id}
    <SectionBoard klass="ml-6">
      <DetailSection
        model={$model}
        handleLabel={service.handleName}
        hasOrder={false}
        hasDisabled={false}
        save={service.save}
        remove={service.remove}
        loading={$loading}
        max={$size}
      >
        <div class="mt-6">
          <FormWithLabel
            label="URL"
            input={service.handleUrl}
            value={$model.url}
          />
        </div>

        <div class="mt-6">
          <FormWithLabel
            label="コード"
            input={service.handleCode}
            value={$model.code}
            inputType="textarea"
          />
        </div>
      </DetailSection>
    </SectionBoard>
  {/if}
</div>
